var map = {
	"./Accordion.svg": 537,
	"./Breadcrumb.svg": 538,
	"./Button.svg": 539,
	"./Checkbox.svg": 540,
	"./Code snippet.svg": 541,
	"./Content switcher.svg": 542,
	"./Data table.svg": 543,
	"./Date picker.svg": 544,
	"./Dropdown.svg": 545,
	"./File uploader.svg": 546,
	"./Form.svg": 547,
	"./Inline loading.svg": 548,
	"./Link.svg": 549,
	"./List.svg": 550,
	"./Loading.svg": 551,
	"./Modal.svg": 552,
	"./Multiselect.svg": 553,
	"./NoImage.svg": 340,
	"./Notification.svg": 554,
	"./Number input.svg": 555,
	"./Overflow menu.svg": 556,
	"./Pagination.svg": 557,
	"./Progress indicator.svg": 558,
	"./Radio button.svg": 559,
	"./Search.svg": 560,
	"./Select.svg": 561,
	"./Slider.svg": 562,
	"./Structured list.svg": 563,
	"./Tabs.svg": 564,
	"./Tag.svg": 565,
	"./Text input.svg": 566,
	"./Tile.svg": 567,
	"./Toggle.svg": 568,
	"./Tooltip.svg": 569,
	"./UI shell.svg": 570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 536;